<template>
  <div>
    <a-alert class="mb10" v-if="error_message" type="error" :message="error_message" />
    <a-form id="components-form-demo-normal-login" :form="form" class="login-form" @submit="onHandleLogin">
      <a-form-item style="margin-bottom: 5px">
        <a-input
          v-decorator="['username', { rules: [{ required: true, message: 'Username is required' }] }]"
          placeholder="Username"
        >
          <a-icon slot="prefix" type="user" style="color: rgba(0, 0, 0, 0.25)" />
        </a-input>
      </a-form-item>
      <a-form-item style="margin-bottom: 5px">
        <a-input
          v-decorator="['password', { rules: [{ required: true, message: 'Password is required' }] }]"
          type="password"
          placeholder="Password"
        >
          <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, 0.25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" :loading="loading" html-type="submit" class="login-form-button">Log in</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import JSEncrypt from "jsencrypt";

export default {
  name: "FormLogin",

  data() {
    return {
      form: this.$form.createForm(this, { name: "normal_login", onValuesChange: this.onValuesChange }),
      error_message: undefined,
      loading: false,
    };
  },
  methods: {
    onValuesChange(_, values) {
      if (values?.username || values?.password) {
        this.error_message = undefined;
      }
    },
    onHandleLogin(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;
          const encrypt = new JSEncrypt();
          encrypt.setPublicKey(`${process.env.VUE_APP_PUBLIC_KEY}`);
          let payload = {
            username: encrypt.encrypt(values.username),
            password: encrypt.encrypt(values.password),
          };
          this.$store
            .dispatch("user/userLogin", payload)
            .then((res) => {
              if (res) {
                this.$router.push("/").catch(() => {
                  throw e;
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.error_message = error.response.data.errorMessage;
            });
        }
      });
    },
  },
};
</script>
